import { render, staticRenderFns } from "./ActiveUserRow.vue?vue&type=template&id=bc2ff7e0&"
import script from "./ActiveUserRow.vue?vue&type=script&lang=js&"
export * from "./ActiveUserRow.vue?vue&type=script&lang=js&"
import style0 from "./ActiveUserRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports